<script setup>
import {onMounted, defineEmits, ref, defineProps, defineExpose} from 'vue'

// Props & emits
let emit = defineEmits(['changed'])

const props = defineProps({
  activeRequestFields: {
    type: Object,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const defaultFormData = {
  preland_url: '',
  offer_url: '',
  geo: '',
  comment: '',
  auth_url: '',
}
let formData = ref(cloneSafe(defaultFormData))

// Methods
onMounted(() => {
  init()
})

const init = () => {
  if (props.activeRequestFields) {
    formData.value = Object.assign(formData.value, props.activeRequestFields)
  }
}

const resetForm = () => {
  formData.value = cloneSafe(defaultFormData)
}

const onChange = () => {
  emit('changed', {fields: formData.value})
}

defineExpose({resetForm})
</script>

<template>
  <div class="form-group">
    <label for="bing-gambling-wl-offer_url">Offer URL *</label>
    <div class="input-group">
      <input
        v-model="formData.offer_url"
        @change="onChange"
        class="form-control"
        id="bing-gambling-wl-offer_url"
        type="url"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="bing-gambling-wl-preland_url">Preland URL <small class="muted">(if there is one)</small> </label>
    <div class="input-group">
      <input
        v-model="formData.preland_url"
        @change="onChange"
        class="form-control"
        id="bing-gambling-wl-preland_url"
        type="url"
        :disabled="disabled"
      />
    </div>
  </div>
  <div class="form-group">
    <label for="bing-gambling-wl-geo">Target Geo *</label>
    <div class="input-group">
      <input
        v-model="formData.geo"
        @change="onChange"
        class="form-control"
        id="bing-gambling-wl-geo"
        type="text"
        :disabled="disabled"
        required
      />
    </div>
  </div>

  <div class="form-group">
    <label for="bing-gambling-wl-auth_url">URL to authorization or to a Google file with the documents *</label>
    <div class="input-group">
      <input
        v-model="formData.auth_url"
        @change="onChange"
        class="form-control"
        id="bing-gambling-wl-auth_url"
        type="url"
        :disabled="disabled"
        required
      />
    </div>
  </div>
  <div class="form-group">
    <label for="bing-gambling-wl-comment">Any Comments That You Would Like to Add</label>
    <div class="input-group">
      <textarea
        v-model="formData.comment"
        @change="onChange"
        class="form-control"
        id="bing-gambling-wl-comment"
        :disabled="disabled"
        rows="3"
      />
    </div>
  </div>
</template>
